import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./Components/Pages/Login";
import ChildList from "./Components/Pages/ChildList";
import ReportList from "./Components/Pages/ReportList";
import SchoolReportList from "./Components/Pages/SchoolReportList";

import { IntlProvider, FormattedMessage } from "react-intl";
import messages from "./locales";

const App: React.FC = () => {
  const [language, setLanguage] = useState<"en" | "tr" | "ar">(
    (localStorage.getItem("selectedLanguage") as "en" | "tr" | "ar") || "tr"
  ); // Varsayılan dili Türkçe olarak ayarladık

  return (
    <IntlProvider
      locale={language}
      messages={messages[language] as unknown as Record<string, string>}
    >
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/schoolreportlist" element={<SchoolReportList />} />
        {/*<Route path="/childlist" element={<ChildList />} />*/}
        <Route path="/reportlist" element={<ReportList />} />
        <Route path="*" element={<Navigate to="/login" />} />{" "}
        {/* Bilinmeyen yönlendirmeler için */}
      </Routes>
    </IntlProvider>
  );
};

const AppWrapper: React.FC = () => {
  useEffect(() => {
    document.title = "Eyelexia";
  }, []);
  return (
    <Router>
      <App />
    </Router>
  );
};
export default AppWrapper;
